import ErrorSwitchCase from '../../services/ErrorHandlerService';
import HttpService from '../../services/HttpService';
import { WORKFLOW_PATH } from '../../url';

const _axios = HttpService.getAxiosClient();

export const getHRLeavesRequests = async (
  userId,
  filterData,
  pageSize,
  pageNumber,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application/hr?${
        filterData.startDate ? 'startDate=' + filterData.startDate + '&' : ''
      }${filterData.endDate ? 'endDate=' + filterData.endDate + '&' : ''}${
        filterData.employeeId ? 'applierId=' + filterData.employeeId + '&' : ''
      }${filterData.status ? 'status=' + filterData.status + '&' : ''}${
        filterData.projectId ? 'projectId=' + filterData.projectId + '&' : ''
      }${filterData.leaveId ? 'leaveId=' + filterData.leaveId + '&' : ''}${
        pageSize ? 'pageSize=' + pageSize + '&' : ''
      }${pageNumber >= 0 ? 'pageNumber=' + pageNumber : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getHRWFHRequests = async (
  userId,
  filterData,
  pageSize,
  pageNumber,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application/hr?type=WFH&${
        filterData.startDate ? 'startDate=' + filterData.startDate + '&' : ''
      }${filterData.endDate ? 'endDate=' + filterData.endDate + '&' : ''}${
        filterData.employeeId ? 'applierId=' + filterData.employeeId + '&' : ''
      }${filterData.status ? 'status=' + filterData.status + '&' : ''}${
        filterData.projectId ? 'projectId=' + filterData.projectId + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
